/* unplugin-vue-components disabled */import script from "./SiliconflowList2.vue?vue&type=script&setup=true&lang=js"
export * from "./SiliconflowList2.vue?vue&type=script&setup=true&lang=js"

import "./SiliconflowList2.vue?vue&type=style&index=0&id=f477e442&lang=css"

const __exports__ = script;

export default __exports__